import { useTranslation } from "react-i18next";
import { ConfirmModal } from "./ConfirmModal";

export function Delete() {
  const { t } = useTranslation();

  const contentProps = {
    title: t("remove"),
    description: t("confirmRemove"),
  };

  return <ConfirmModal {...contentProps} />;
}
